import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import SampleFileSource from 'Components/Utility/Sample/SampleFileSource';

function SampleVideo({ files }) {
  return (
    <video controls width="100%" height="auto" id="sample-video-player">
      {files.map(file =>
        <SampleFileSource file={file} key={file._id} type="video" />,
      )}
      <FormattedMessage
        id="sample-video.no-support"
        defaultMessage="Your browser does not support the sample video element."
      />
    </video>
  );
}

SampleVideo.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({})),
};

SampleVideo.defaultProps = {
  files: [],
};

export default SampleVideo;
